import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty, update } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DeleteModal from "../../../components/Common/DeleteModal"

import { deleteLevel, getLevels, updateLevel } from "store/actions"

import { Commission, Level } from "./LevelCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import { Col, Row, UncontrolledTooltip, Card, CardBody } from "reactstrap"
import LevelModal from "./LevelModal"
import { withTranslation } from "react-i18next"
import ShowModal from "./ShowModal"
import { checkPermission } from "helpers/functions"

function LevelCommission(props) {
  //meta title
  document.title = "Kasb"

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [level, setLevel] = useState(null)
  const [show, setShow] = useState(false)
  const [filter, setFilter] = useState({
		page:1,
		limit:100,
	  })

  const dispatch = useDispatch()

  const {
    levels,
    error,
    success,
    nextPage,
    currentPage,
    previousPage,
    total,
    limit,
    loading,
  } = useSelector(state => state.levels)
  const userRoles = useSelector(state => state.Login.user?.roles)

  useEffect(() => {
    dispatch(getLevels(filter))
  }, [dispatch,filter])

  useEffect(() => {
    if (!isEmpty(levels) && !!isEdit) {
      setIsEdit(false)
    }
  }, [levels])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setLevel(null)
    } else {
      setModal(true)
    }
  }

  const toggleShow = () => {
    setShow(!show)
  }

  const handleOrderClick = arg => {
    const level = arg
    setLevel({
      id: level.id,
      name: level.name,
      value: level.value,
      level: level.level,
    })

    setIsEdit(true)

    toggle()
  }

  //delete order
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = level => {
    setLevel(level)
    setDeleteModal(true)
  }

  const handleDeleteLevel = () => {
    if (level.id) {
      dispatch(updateLevel({ id: level.id, status: "archived" }))
      setDeleteModal(false)
      dispatch(getLevels())
    }
  }
  const handleOrderClicks = () => {
    setIsEdit(false)
    toggle()
  }

  const columns = useMemo(
    () => [
      {
        Header: props.t("Name"),
        accessor: "name",
        disableFilters: true,
        accessor: cellProps => {
          return (
            <div
              className="external-event"
              onClick={() => {
                setLevel(cellProps)
                toggleShow()
              }}
            >
              {cellProps.name}
            </div>
          )
        },
      },
      {
        Header: props.t("Level"),
        accessor: "level",
        disableFilters: true,
        Cell: cellProps => {
          return <Level {...cellProps} />
        },
      },
      {
        Header: props.t("Commission") + "%",
        accessor: "value",
        disableFilters: true,
        Cell: cellProps => {
          return <Commission {...cellProps} />
        },
      },

      {
        Header: props.t("Action"),
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="text-center">
              {checkPermission(userRoles, ["MasterData", "LevelCommission", "Update"]) && 
              <Link
                to="#"
                className="text-tip"
                onClick={() => {
                  const orderData = cellProps.row.original
                  handleOrderClick(orderData)
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  {props.t("Edit")}
                </UncontrolledTooltip>
              </Link>}
            </div>
          )
        },
      },
    ],
    []
  )

  const setPageNumber = (activePage ) => {setFilter(prevFilter => {return {...prevFilter, page:activePage }})}
  const handleLimit =(limit)=>{setFilter(prevFilter => {return {...prevFilter, limit:limit }})}

  return (
    <React.Fragment>
      <LevelModal modal={modal} toggle={toggle} isEdit={isEdit} level={level} />
      <ShowModal modal={show} toggle={toggleShow} level={level} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteLevel}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={props.t("MDM")}
            breadcrumbItem={props.t("Level Commission list")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={levels}
                    //isGlobalFilter={true}
                    isAddOptions={checkPermission(userRoles, ["MasterData", "LevelCommission", "Create"])}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={100}
                    setPageNumber={setPageNumber}
                    setLimit={handleLimit}
                    currentPage={currentPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    total={total}
                    limit={limit}
                    loading={loading}
                    success={success}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
LevelCommission.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  t: PropTypes.any,
}

export default withTranslation()(LevelCommission)
